/**
 * 請求先
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/billing_addresses`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      limit: 50,
      code: null,
      name: null,
      prefecture_code: null,
      address: null,
      closing_date_type: null,
      payment_method_type: null,
    },
  }
}

const billing_addresses = {

  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 公共積替取得
     * @param dispatch
     * @param commit
     * @param state
     * @param code
     * @param name
     * @param prefecture_code
     * @param address
     * @param closing_date_type
     * @param payment_method_type
     * @param page
     * @param limit
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { code, name, prefecture_code, address, closing_date_type, payment_method_type, page, limit, format }) {
      let api_path
      if (format === 'csv') {
        api_path = `${API_PATH}.csv`
      } else {
        api_path = `${API_PATH}`
      }
      dispatch('saveCondition', { code: code, name: name, prefecture_code: prefecture_code, address: address, closing_date_type: closing_date_type, payment_method_type: payment_method_type, limit: limit})
      const params = {
        code: state.condition.code,
        name: state.condition.name,
        prefecture_code: state.condition.prefecture_code,
        address: state.condition.address,
        closing_date_type: state.condition.closing_date_type,
        payment_method_type: state.condition.payment_method_type,
        limit: limit,
        page: page
      }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          if ((format != 'csv')) {
            let content = data.content
            commit(types.DRIVER_BILLING_ADDRESS, { content })
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { code, name, prefecture_code, address, closing_date_type, payment_method_type,limit }) {
      const _code = (code !== undefined) ? code : state.condition.code
      const _name = (name !== undefined) ? name : state.condition.name
      const _prefecture_code = (prefecture_code !== undefined) ? prefecture_code : state.condition.prefecture_code
      const _address = (address !== undefined) ? address : state.condition.address
      const _closing_date_type = (closing_date_type !== undefined) ? closing_date_type : state.condition.closing_date_type
      const _payment_method_type = (payment_method_type !== undefined) ? payment_method_type : state.condition.payment_method_type
      const _limit = (limit !== undefined) ? limit : state.condition.limit
      const params = { code: _code, name: _name, prefecture_code: _prefecture_code, address: _address, closing_date_type: _closing_date_type, payment_method_type: _payment_method_type, limit: _limit }
      commit(types.DRIVER_BILLING_ADDRESS_CONDITION, { params })
    },
    resetState({ commit }) {
      commit(types.DRIVER_BILLING_ADDRESS_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_BILLING_ADDRESS_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_BILLING_ADDRESS_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_BILLING_ADDRESS_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.DRIVER_BILLING_ADDRESS] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_BILLING_ADDRESS_CONDITION] (state, { params }) {
      state.condition.code = params.code
      state.condition.name = params.name
      state.condition.prefecture_code = params.prefecture_code
      state.condition.address = params.address
      state.condition.closing_date_type = params.closing_date_type
      state.condition.payment_method_type = params.payment_method_type
      state.condition.limit = params.limit
    }
  },
}

export default billing_addresses

